// extracted by mini-css-extract-plugin
export default {"nav-logo":"App_nav-logo__oAnC4","btn":"App_btn__lhw8E"};